import React from 'react';
import PropTypes from 'prop-types'
import { Box } from 'tailwind-react-ui';

const FloatingButton = ({onClick}) =>{

    return(
        <Box className="floating-button" rounded={'full'} fixed z={'30'}>
            <Box onClick={() => onClick()} style={{cursor: 'pointer'}}>
                <img className="flex m-auto w-16 md:w-20"
                src={'https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/chelas-2x1.gif'}
                alt={'cupon-chelas-gratis'}/>
            </Box>
        </Box>
    );
}

FloatingButton.propTypes = {
    onClick: PropTypes.func
}

export default FloatingButton;